import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { Observable, Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { HospitalService } from 'src/app/components/pages/_services';
import { AuthService } from '../../auth';
import { LabService } from '../../lab/_services';
import { RadiologyService } from '../../radiology/_services';
import { AppointmentService } from '../_services/appointments.service';

@Component({
  selector: 'app-another-service',
  templateUrl: './another-service.component.html',
  styleUrls: ['./another-service.component.scss']
})
export class AnotherServiceComponent implements OnInit , OnDestroy{
  language: any;
  isLoading$: Observable<boolean>;
  AppointmentDetails:any;
  private subscriptions: Subscription[] = []; 
  constructor(private translationService: TranslationService,
    private HospitalService: HospitalService,
   private auth: AuthService,private LabService: LabService, private RadiologyService : RadiologyService,private AppointmentService: AppointmentService) { }

  ngOnInit(): void {
    if (localStorage.getItem("AppointmentDetails")) {
      this.AppointmentDetails = JSON.parse(localStorage.getItem("AppointmentDetails"));
    }
    this.language = this.translationService.getSelectedLanguage();
    this.isLoading$ = this.HospitalService.isLoading$;
  }
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
    localStorage.removeItem('AppointmentDetails')
  }
  logout() {
    this.auth.logout();
    this.LabService.Clearitems$();
    this.RadiologyService.Clearitems$();
    this.AppointmentService.Clearitems$();
  }

}
